import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b1a7d6ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "periodontal-report-creation" }
const _hoisted_2 = { class: "periodontal-report-creation__content" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Сохранить ")

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { EPeriodontalGraphic } from '@/entities/EPeriodontalGraphic'
import { EPeriodontalMapTable } from '@/entities/EPeriodontalMapTable'
import { FullPeriodontalType, PeriodontalDiagramType } from '@/shared/types'
import { JAW_TYPES } from '@/shared/constants'
import { periodontalReportApi } from '@/shared/api'
import { PeriodontalData, showErrorMessage } from '@/shared/utils'
import { usePeriodontalReport, useReportListing } from '@/shared/composables'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: Boolean,
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props





const { setUpdateReportListing } = useReportListing()
const { setUpdateReport } = usePeriodontalReport()

const route = useRoute()
const router = useRouter()

const loading = ref(false)

const firstFacialData = ref<PeriodontalData>(
  new PeriodontalData(JAW_TYPES.jawUp)
)
const firstTongueData = ref<PeriodontalData>(
  new PeriodontalData(JAW_TYPES.jawUp, true)
)
const secondFacialData = ref<PeriodontalData>(
  new PeriodontalData(JAW_TYPES.jawDown)
)
const secondTongueData = ref<PeriodontalData>(
  new PeriodontalData(JAW_TYPES.jawDown)
)

const firstFacialDiagram = computed(
  (): PeriodontalDiagramType => firstFacialData.value.getDiagramData()
)
const firstTongueDiagram = computed(
  (): PeriodontalDiagramType => firstTongueData.value.getDiagramData(true)
)
const secondFacialDiagram = computed(
  (): PeriodontalDiagramType => secondFacialData.value.getDiagramData(true)
)
const secondTongueDiagram = computed(
  (): PeriodontalDiagramType => secondTongueData.value.getDiagramData()
)

const reportId = computed(() => Number(route.params.reportId))
const patientId = computed(() => Number(route.params.patientId))

watch(
  () => props.visible,
  (newValue) => {
    if (newValue) {
      if (reportId.value) {
        getReport()
      } else {
        initEmptyPeriodontalData()
      }
    }
  }
)

watch(reportId, (newReportId) => {
  if (route.name === 'PeriodontalPage' && newReportId) {
    if (reportId.value) {
      getReport()
    } else {
      initEmptyPeriodontalData()
    }
  }
})

const getReport = async (): Promise<void> => {
  loading.value = true

  const [error, response] = await periodontalReportApi.getReport(reportId.value)

  if (error) {
    showErrorMessage(error)
  } else {
    const periodontalReport = JSON.parse(response.data.report.index)

    firstFacialData.value.setData(periodontalReport.firstFacialData)
    firstTongueData.value.setData(periodontalReport.firstTongueData)
    secondFacialData.value.setData(periodontalReport.secondFacialData)
    secondTongueData.value.setData(periodontalReport.secondTongueData)
  }

  loading.value = false
}

const initEmptyPeriodontalData = () => {
  firstFacialData.value = new PeriodontalData(JAW_TYPES.jawUp)
  firstTongueData.value = new PeriodontalData(JAW_TYPES.jawUp, true)
  secondFacialData.value = new PeriodontalData(JAW_TYPES.jawDown)
  secondTongueData.value = new PeriodontalData(JAW_TYPES.jawDown)
}

const handleClickUpTeethColumn = (columnId: number): void => {
  firstFacialData.value.changeStatus(columnId)
  firstTongueData.value.changeStatus(columnId)
}

const handleResetUpToothData = (columnId: number): void => {
  firstFacialData.value.resetData(columnId)
  firstTongueData.value.resetData(columnId)
}

const handleResetDownToothData = (columnId: number): void => {
  secondFacialData.value.resetData(columnId)
  secondTongueData.value.resetData(columnId)
}

const handleClickDownTeethColumn = (columnId: number): void => {
  secondFacialData.value.changeStatus(columnId)
  secondTongueData.value.changeStatus(columnId)
}

const handleClickUpTeethMobility = (columnId: number): void => {
  firstFacialData.value.changeMobility(columnId)
  firstTongueData.value.changeMobility(columnId)
}

const handleClickDownTeethMobility = (columnId: number): void => {
  secondFacialData.value.changeMobility(columnId)
  secondTongueData.value.changeMobility(columnId)
}

const createReport = async (report: FullPeriodontalType): Promise<void> => {
  const [error, response] = await periodontalReportApi.saveReport(
    patientId.value,
    report
  )

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      message: 'Отчет сохранен',
      type: 'success',
    })

    if (!reportId.value) {
      setUpdateReportListing(true)

      router.push({
        name: 'PeriodontalPage',
        params: {
          patientId: patientId.value,
          reportId: response.data.report_id,
        },
      })
    }

    emit('close')
  }
}

const updateReport = async (report: FullPeriodontalType): Promise<void> => {
  const [error] = await periodontalReportApi.updateReport(
    reportId.value,
    report
  )

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      message: 'Отчет обновлен',
      type: 'success',
    })

    setUpdateReport(true)

    emit('close')
  }
}

const handleSaveReport = (): void => {
  const periodontalReportData: FullPeriodontalType = {
    firstFacialData: firstFacialData.value.getData(),
    firstFacialDiagram: firstFacialDiagram.value,
    firstTongueData: firstTongueData.value.getData(),
    firstTongueDiagram: firstTongueDiagram.value,
    secondFacialData: secondFacialData.value.getData(),
    secondFacialDiagram: secondFacialDiagram.value,
    secondTongueData: secondTongueData.value.getData(),
    secondTongueDiagram: secondTongueDiagram.value,
  }

  if (!reportId.value) {
    createReport(periodontalReportData)
  } else {
    updateReport(periodontalReportData)
  }
}

onMounted((): void => {
  if (reportId.value) {
    getReport()
  } else {
    initEmptyPeriodontalData()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(EPeriodontalMapTable), {
        columns: firstFacialData.value.getData(),
        class: "periodontal-report-creation__table",
        "is-interactive": "",
        onBleeding: _cache[0] || (_cache[0] = 
          (columnId, bleedingId) =>
            firstFacialData.value.changeBleeding(columnId, bleedingId)
        ),
        onFuration: _cache[1] || (_cache[1] = 
          (columnId, furationId) =>
            firstFacialData.value.changeFuration(columnId, furationId)
        ),
        onMobility: handleClickUpTeethMobility,
        onPlaque: _cache[2] || (_cache[2] = 
          (columnId, plaqueId) =>
            firstFacialData.value.changePlaque(columnId, plaqueId)
        ),
        onRecession: _cache[3] || (_cache[3] = 
          (columnId, recessionId, value) =>
            firstFacialData.value.changeRecession(columnId, recessionId, value)
        ),
        onReset: handleResetUpToothData,
        onSounding: _cache[4] || (_cache[4] = 
          (columnId, soundingId, value) =>
            firstFacialData.value.changeSounding(columnId, soundingId, value)
        ),
        onSuppuration: _cache[5] || (_cache[5] = 
          (columnId, suppurationId) =>
            firstFacialData.value.changeSuppuration(columnId, suppurationId)
        ),
        onChangeStatus: handleClickUpTeethColumn
      }, null, 8, ["columns"]),
      _createVNode(_unref(EPeriodontalGraphic), {
        "facial-side-data": _unref(firstFacialDiagram),
        "is-upper-teeth": true,
        "tongue-side-data": _unref(firstTongueDiagram),
        class: "periodontal-report-creation__chart",
        "is-interactive": ""
      }, null, 8, ["facial-side-data", "tongue-side-data"]),
      _createVNode(_unref(EPeriodontalMapTable), {
        columns: firstTongueData.value.getData(),
        class: "periodontal-report-creation__table-last",
        "is-interactive": "",
        "is-reverse": "",
        onBleeding: _cache[6] || (_cache[6] = 
          (columnId, bleedingId) =>
            firstTongueData.value.changeBleeding(columnId, bleedingId)
        ),
        onFuration: _cache[7] || (_cache[7] = 
          (columnId, furationId) =>
            firstTongueData.value.changeFuration(columnId, furationId)
        ),
        onMobility: handleClickUpTeethMobility,
        onPlaque: _cache[8] || (_cache[8] = 
          (columnId, plaqueId) =>
            firstTongueData.value.changePlaque(columnId, plaqueId)
        ),
        onRecession: _cache[9] || (_cache[9] = 
          (columnId, recessionId, value) =>
            firstTongueData.value.changeRecession(columnId, recessionId, value)
        ),
        onReset: handleResetUpToothData,
        onSounding: _cache[10] || (_cache[10] = 
          (columnId, soundingId, value) =>
            firstTongueData.value.changeSounding(columnId, soundingId, value)
        ),
        onSuppuration: _cache[11] || (_cache[11] = 
          (columnId, suppurationId) =>
            firstTongueData.value.changeSuppuration(columnId, suppurationId)
        ),
        onChangeStatus: handleClickUpTeethColumn
      }, null, 8, ["columns"]),
      _createVNode(_unref(EPeriodontalMapTable), {
        columns: secondTongueData.value.getData(),
        class: "periodontal-report-creation__chart",
        "is-interactive": "",
        onBleeding: _cache[12] || (_cache[12] = 
          (columnId, bleedingId) =>
            secondTongueData.value.changeBleeding(columnId, bleedingId)
        ),
        onFuration: _cache[13] || (_cache[13] = 
          (columnId, furationId) =>
            secondTongueData.value.changeFuration(columnId, furationId)
        ),
        onMobility: handleClickDownTeethMobility,
        onPlaque: _cache[14] || (_cache[14] = 
          (columnId, plaqueId) =>
            secondTongueData.value.changePlaque(columnId, plaqueId)
        ),
        onRecession: _cache[15] || (_cache[15] = 
          (columnId, recessionId, value) =>
            secondTongueData.value.changeRecession(columnId, recessionId, value)
        ),
        onReset: handleResetDownToothData,
        onSounding: _cache[16] || (_cache[16] = 
          (columnId, soundingId, value) =>
            secondTongueData.value.changeSounding(columnId, soundingId, value)
        ),
        onSuppuration: _cache[17] || (_cache[17] = 
          (columnId, suppurationId) =>
            secondTongueData.value.changeSuppuration(columnId, suppurationId)
        ),
        onChangeStatus: handleClickDownTeethColumn
      }, null, 8, ["columns"]),
      _createVNode(_unref(EPeriodontalGraphic), {
        "facial-side-data": _unref(secondTongueDiagram),
        "tongue-side-data": _unref(secondFacialDiagram),
        class: "periodontal-report-creation__chart",
        "is-interactive": "",
        "is-reverse": ""
      }, null, 8, ["facial-side-data", "tongue-side-data"]),
      _createVNode(_unref(EPeriodontalMapTable), {
        columns: secondFacialData.value.getData(),
        "is-interactive": "",
        "is-reverse": "",
        onBleeding: _cache[18] || (_cache[18] = 
          (columnId, bleedingId) =>
            secondFacialData.value.changeBleeding(columnId, bleedingId)
        ),
        onFuration: _cache[19] || (_cache[19] = 
          (columnId, furationId) =>
            secondFacialData.value.changeFuration(columnId, furationId)
        ),
        onMobility: handleClickDownTeethMobility,
        onPlaque: _cache[20] || (_cache[20] = 
          (columnId, plaqueId) =>
            secondFacialData.value.changePlaque(columnId, plaqueId)
        ),
        onRecession: _cache[21] || (_cache[21] = 
          (columnId, recessionId, value) =>
            secondFacialData.value.changeRecession(columnId, recessionId, value)
        ),
        onReset: handleResetDownToothData,
        onSounding: _cache[22] || (_cache[22] = 
          (columnId, soundingId, value) =>
            secondFacialData.value.changeSounding(columnId, soundingId, value)
        ),
        onSuppuration: _cache[23] || (_cache[23] = 
          (columnId, suppurationId) =>
            secondFacialData.value.changeSuppuration(columnId, suppurationId)
        ),
        onChangeStatus: handleClickDownTeethColumn
      }, null, 8, ["columns"])
    ]),
    _createVNode(_component_el_button, {
      class: "periodontal-report-creation__button",
      round: "",
      type: "primary",
      onClick: handleSaveReport
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})